import Header from "../../Layouts/Header/Header";
import MainContainer from "../../UI/MainContainer";
import SubMainContainer from "../../UI/SubMainContainer";
import SideBar from "../../Layouts/SideBar/SideBar";
import PackageCreationPageContent from "../../Package/PackageCreationPageContent";
import AddCustomer from "../Customer/AddCustomer"

const CreatePackage = () => {
  return (
    <>
      <MainContainer>
        <Header />
        <SubMainContainer>
          <SideBar />
          <AddCustomer />
        </SubMainContainer>
      </MainContainer>
    </>
  );
};

export default CreatePackage;
